module.exports = __webpack_public_path__ + "assets/images/et-feature@2x-f2df27cd9a7a72bbf54454d82c8e8668.png";